import { render, staticRenderFns } from "./liveAnswerRecord.vue?vue&type=template&id=0c78e9fe&scoped=true"
import script from "./liveAnswerRecord.vue?vue&type=script&lang=js"
export * from "./liveAnswerRecord.vue?vue&type=script&lang=js"
import style0 from "./liveAnswerRecord.vue?vue&type=style&index=0&id=0c78e9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78e9fe",
  null
  
)

export default component.exports